module.exports = __webpack_public_path__ + "static/media/AddBankIcon.f3867f4e.svg";